/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
/* eslint-disable id-length */
/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable func-names */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-else-return */

export const filterByMonths = async (months, json) => {
  if(months && json){
    let overallRec = 0;
    let receivedMaximServeAthletes = 0;
    let receivedMaximCreateTheFutureOfSport = 0;
    let receivedMaximBeOnTheOffenseAlways = 0;
    let receivedMaximDoTheRightThing = 0;
    let receivedMaximWinAsATeam = 0;
    let receivedValuesServeYouth = 0;
    let receivedValuesSparkProgress = 0;
    let receivedValuesDareGreatly = 0;
    let receivedValuesDoTheRightThing = 0;
    let receivedValuesWinTogether = 0

    let overallSent = 0;
    let sentMaximServeAthletes = 0;
    let sentMaximCreateTheFutureOfSport = 0;
    let sentMaximBeOnTheOffenseAlways = 0;
    let sentMaximDoTheRightThing = 0;
    let sentMaximWinAsATeam = 0;
    let sentValuesServeYouth = 0;
    let sentValuesSparkProgress = 0;
    let sentValuesDareGreatly = 0;
    let sentValuesDoTheRightThing = 0;
    let sentValuesWinTogether = 0;

    let sentmonthArray = [{}];
    let receivedmonthArray = [{}];

    const jsonData = json;

    let month = new Date().setMonth(new Date().getMonth() - months);
    month = month.valueOf();

    if(jsonData[0].sent){
      sentmonthArray = await jsonData[0].sent.filter(data =>{
        if(new Date(data.date).valueOf() > month){
          switch((data.maxim || '').toLowerCase()){
            case 'serve athletes*': {
              sentMaximServeAthletes += 1;
              overallSent += 1;
              return true
            }
            case 'create the future of sport': {
              sentMaximCreateTheFutureOfSport += 1;
              overallSent += 1;
              return true
            }
            case 'be on the offense always': {
              sentMaximBeOnTheOffenseAlways += 1;
              overallSent += 1;
              return true
            }
            case 'do the right thing': {
              sentMaximDoTheRightThing += 1;
              sentValuesDoTheRightThing +=1;
              overallSent += 1;
              return true
            }
            case 'win as a team': {
              sentMaximWinAsATeam += 1;
              overallSent += 1;
              return true
            }
            case 'serve youth': {
              sentValuesServeYouth += 1;
              overallSent += 1;
              return true
            }
            case 'spark progress': {
              sentValuesSparkProgress += 1;
              overallSent += 1;
              return true
            }
            case 'dare greatly': {
              sentValuesDareGreatly += 1;
              overallSent += 1;
              return true
            }
            case 'win together': {
              sentValuesWinTogether += 1;
              overallSent += 1;
              return true
            }
            default: {
              return false
            }
          }
        }
      })
      sentmonthArray = [{ 'sent': sentmonthArray}];
  } else {
    sentmonthArray = [{}]
  }

  if(jsonData[1].received){
    receivedmonthArray = await jsonData[1].received.filter(data =>{
      if(new Date(data.date).valueOf() > month){
        switch((data.maxim || '').toLowerCase()){
          case 'serve athletes*': {
            receivedMaximServeAthletes += 1;
            overallRec += 1;
            return true
          }
          case 'create the future of sport': {
            receivedMaximCreateTheFutureOfSport += 1;
            overallRec += 1;
            return true
          }
          case 'be on the offense always': {
            receivedMaximBeOnTheOffenseAlways += 1;
            overallRec += 1;
            return true
          }
          case 'do the right thing': {
            receivedMaximDoTheRightThing += 1;
            receivedValuesDoTheRightThing +=1;
            overallRec += 1;
            return true
          }
          case 'win as a team': {
            receivedMaximWinAsATeam += 1;
            overallRec += 1;
            return true
          }
          case 'serve youth': {
            receivedValuesServeYouth += 1;
            overallRec += 1;
            return true
          }
          case 'spark progress': {
            receivedValuesSparkProgress += 1;
            overallRec += 1;
            return true
          }
          case 'dare greatly': {
            receivedValuesDareGreatly += 1;
            overallRec += 1;
            return true
          }
          case 'win together': {
            receivedValuesWinTogether += 1;
            overallRec += 1;
            return true
          }
          default: {
            return false
          }
        }
      }
    })
    receivedmonthArray = [{'received': receivedmonthArray}];
  } else {
    receivedmonthArray = [{}]
  }

    const finalmonthSubmissions = sentmonthArray.concat(receivedmonthArray);

    return (
      [{
        finalmonthSubmissions,
        overallRec,
        overallSent,
        receivedMaximServeAthletes,
        receivedMaximCreateTheFutureOfSport,
        receivedMaximBeOnTheOffenseAlways,
        receivedMaximDoTheRightThing,
        receivedMaximWinAsATeam,
        receivedValuesServeYouth,
        receivedValuesSparkProgress,
        receivedValuesDareGreatly,
        receivedValuesDoTheRightThing,
        receivedValuesWinTogether,
        sentMaximServeAthletes,
        sentMaximCreateTheFutureOfSport,
        sentMaximBeOnTheOffenseAlways,
        sentMaximDoTheRightThing,
        sentMaximWinAsATeam,
        sentValuesServeYouth,
        sentValuesSparkProgress,
        sentValuesDareGreatly,
        sentValuesDoTheRightThing,
        sentValuesWinTogether,
      }]
    );
  }
}

export const filterByYear = async (json) => {
  if(json){
    let overallRec = 0;
    let recServeAthletes = 0;
    let recCreateTheFutureOfSport = 0;
    let recBeOnTheOffenseAlways = 0;
    let recDoTheRightThing = 0;
    let recWinAsATeam = 0;

    let overallSent = 0;
    let sentServeAthletes = 0;
    let sentCreateTheFutureOfSport = 0;
    let sentBeOnTheOffenseAlways = 0;
    let sentDoTheRightThing = 0;
    let sentWinAsATeam = 0;

    let sentyearArray = [{}];
    let receivedyearArray = [{}];

    const jsonData = json;

    let year = new Date().setFullYear(new Date().getFullYear() - 1);
    year = year.valueOf();
    if(jsonData[0].sent){
      sentyearArray = await jsonData[0].sent.filter(data =>{
        if(new Date(data.date).valueOf() > year){
          switch(data.maxim){
            case 'Serve Athletes*': {
              sentServeAthletes += 1;
              overallSent += 1;
              return true
            }
            case 'Create the Future of Sport': {
              sentCreateTheFutureOfSport += 1;
              overallSent += 1;
              return true
            }
            case 'Be on the Offense Always': {
              sentBeOnTheOffenseAlways += 1;
              overallSent += 1;
              return true
            }
            case 'Do the Right Thing': {
              sentDoTheRightThing += 1;
              overallSent += 1;
              return true
            }
            case 'Win as a Team': {
              sentWinAsATeam += 1;
              overallSent += 1;
              return true
            }
            default: {
              return false
            }
          }
        }
      })
      sentyearArray = [{ 'sent': sentyearArray}];
  } else {
    sentyearArray = [{}]
  }

  if(jsonData[1].received){
    receivedyearArray = await jsonData[1].received.filter(data =>{
      if(new Date(data.date).valueOf() > year){
        switch(data.maxim){
          case 'Serve Athletes*': {
            recServeAthletes += 1;
            overallRec += 1;
            return true
          }
          case 'Create the Future of Sport': {
            recCreateTheFutureOfSport += 1;
            overallRec += 1;
            return true
          }
          case 'Be on the Offense Always': {
            recBeOnTheOffenseAlways += 1;
            overallRec += 1;
            return true
          }
          case 'Do the Right Thing': {
            recDoTheRightThing += 1;
            overallRec += 1;
            return true
          }
          case 'Win as a Team': {
            recWinAsATeam += 1;
            overallRec += 1;
            return true
          }
          default: {
            return false
          }
        }
      }
    })
    receivedyearArray = [{'received': receivedyearArray}];
  } else {
    receivedyearArray = [{}]
  }

    const finalyearSubmissions = sentyearArray.concat(receivedyearArray);

    return (
      [{
        finalyearSubmissions,
        overallRec,
        overallSent,
        recServeAthletes,
        recCreateTheFutureOfSport,
        recBeOnTheOffenseAlways,
        recDoTheRightThing,
        recWinAsATeam,
        sentServeAthletes,
        sentCreateTheFutureOfSport,
        sentBeOnTheOffenseAlways,
        sentDoTheRightThing,
        sentWinAsATeam
      }]
    );
  }
}

export const filterCaseInsensitive = (filter, row) => {
  const id = filter.pivotId || filter.id;
  const content = row[id];
  if (typeof content !== 'undefined') {
      // filter by text in the table or if it's a object, filter by key
      if (typeof content === 'object' && content !== null && content.key) {
          return String(content.key).toLowerCase().includes((filter.value || '').toLowerCase());
      } else {
          return String(content).toLowerCase().includes((filter.value || '').toLowerCase());
      }
  }
  return true;
};


// WEBPACK FOOTER //
// ./src/services/managerDashboardFunctions.js